__turbopack_context__.v({
  "root": "tweet-skeleton-module__ql4oaW__root",
});
